import styled, { AnyStyledComponent } from 'styled-components';
import { SpotTagStyleProps } from './spotTag.types';
import { StyledButton } from '../Button/button.style';
import Link from '../Link/link';
import COLORS from '../../style/universal.color';

const { mlbWhite, mlbGrey7 } = COLORS;

export const SpotTagContainer: AnyStyledComponent = styled.div`
  display: flex;
  align-items: center;

  ${StyledButton} {
    margin-left: 0.5rem;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const SpotLink: AnyStyledComponent = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

export const TagName = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ dark }: SpotTagStyleProps) => (dark ? mlbWhite : mlbGrey7)};
  line-height: 1rem;
  padding-left: 0.5rem;
  white-space: nowrap;
`;
